// updated to include per-category qualification & inclusions
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

// PER-CATEGORY SACRED FEATURES
// Use exact categoryName from event.categories[].categoryName as key
export const sacredFeaturesByCategory = {
  "BMM 45K": [
    {
      title: "Mountain Lakes",
      description:
        "Run alongside pristine volcanic crater lakes surrounded by lush tropical vegetation. The crystal-clear waters reflect the dramatic mountain peaks above.",
    },
    {
      title: "Waterfalls and Rivers",
      description:
        "Navigate through sections featuring spectacular waterfalls and refreshing mountain streams.",
    },
    {
      title: "Forest Running",
      description:
        "Run deep into mountain forests, shaded by towering trees and rich biodiversity, offering a cool and immersive trail running experience.",
    },
    {
      title: "Highland Villages & Rice Fields",
      description:
        "Run through traditional Balinese mountain villages and scenic rice fields, offering a glimpse into local life and the timeless agricultural landscapes of the highlands.",
    },
  ],
  "BMM 30K": [
    {
      title: "Mountain Lakes",
      description:
        "Run alongside pristine volcanic crater lakes surrounded by lush tropical vegetation. The crystal-clear waters mirror the dramatic mountain landscape, offering moments of calm amid the challenge.",
    },
    {
      title: "Forest Running",
      description:
        "Dive deeper into mountain forests, where long shaded sections, towering trees, and rich biodiversity create a cool yet technically demanding trail running experience.",
    },
    {
      title: "Scenic Views",
      description:
        "Enjoy expansive scenic views along the course, from misty highland landscapes to open sections revealing lakes, forests, and rolling mountain terrain, perfect moments to slow down, breathe, and take it all in.",
    },
  ],
  "BMM 10K": [
    {
      title: "Botanical Garden",
      description:
        "Run through trails inside the botanical garden while enjoying scenic views of the lake and surrounding forest, offering a refreshing and immersive running experience.",
    },
  ],
};

// Global fallback for backward compatibility
export const sacredFeatures = [
  {
    title: "Mountain Lakes",
    description:
      "Run alongside pristine volcanic crater lakes surrounded by lush tropical vegetation. The crystal-clear waters reflect the dramatic mountain peaks above.",
  },
  {
    title: "Waterfalls and Rivers",
    description:
      "Navigate through sections featuring spectacular waterfalls and refreshing mountain streams.",
  },
  {
    title: "Forest Running",
    description:
      "Run deep into mountain forests, shaded by towering trees and rich biodiversity, offering a cool and immersive trail running experience.",
  },
  {
    title: "Highland Villages & Rice Fields",
    description:
      "Run through traditional Balinese mountain villages and scenic rice fields, offering a glimpse into local life and the timeless agricultural landscapes of the highlands.",
  },
];

// EVENT SCHEDULE – BMM 2026
export const eventSchedule = [

  {
    title: "Drop Bags and Final Briefing",
    date: "11 January 2026",
    time: "05:30",
  },
  {
    title: "Start BMM 45K and BMM 30K",
    date: "11 January 2026",
    time: "06:00",
  },
  {
    title: "Start BMM 10K",
    date: "11 January 2026",
    time: "07:00",
  },
  {
    title: "Awarding Ceremony",
    date: "11 January 2026",
    time: "13:00",
  },
  {
    title: "Finish Line Closes (BMM 10K - 3 hours COT)",
    date: "11 January 2026",
    time: "10:00",
  },
  {
    title: "Finish Line Closes (BMM 30K & 45K)",
    date: "11 January 2026",
    time: "14:00",
  },
];

// Intro / paragraph yang muncul di bawah title "Qualification & Race Inclusions"
export const qualificationIntro =
  "The following criteria and rules apply to all entrants. You must meet at least one of the following qualifying performances (times must be from an official race event; ITRA/UTMB index option is accepted only if the result comes from recognized races). We do not accept Strava times or personal GPS records.";

// PER-CATEGORY OVERRIDES
// Use exact categoryName from event.categories[].categoryName as key (e.g. "BMM 45K")
export const qualificationByCategory = {
  "BMM 45K": [
    "Any 30 km trail running race, finished within the official cut-off time",
    "Any standard 42.2 km road marathon finished under 5:00 hours",
    "Any Ironman-distance triathlon run leg (42.2 km) finished under 6:00 hours",
    "An ITRA or UTMB index greater than 350 (only from recognized races)",
  ],
  "BMM 30K": [
    "Any 15 km trail running race, finished within the official cut-off time",
    "Any standard 21.1 km road half-marathon finished within the official cut-off time",
  ],
  "BMM 10K": [
    "No qualification is required, but you must be in good physical condition.",
  ],
};

export const raceInclusionsByCategory = {
  "BMM 45K": [
    "Race Bib Number",
    "Finisher Medal",
    "Race Jersey",
    "Park Entrance Ticket",
  ],
  "BMM 30K": [
    "Race Bib Number",
    "Finisher Medal",
    "Race Jersey",
    "Park Entrance Ticket",
  ],
  "BMM 10K": [
    "Race Bib Number",
    "Finisher Medal",
    "Race Jersey",
    "Park Entrance Ticket",
  ],
};

// BMM Mandatory Gears – 3 KATEGORI: BMM 45K, BMM 30K, BMM 10K
export const mandatoryGearsBMM = {
  "BMM 45K": [],
  "BMM 30K": [],
  "BMM 10K": [], // No mandatory gears for beginner-friendly 10K
};

// Global fallback for qualification and raceInclusions (required by BMM.jsx)
export const qualification = [];
export const raceInclusions = [];

// Function untuk mendapatkan gear icon
export const getGearIcon = (gearName) => {
  const gearIconMap = {
    "running vest/belt": "/gears/01.svg",
    "mobile phone with gpx route": "/gears/02.svg",
    smartwatch: "/gears/03.png",
    "minimum water supply of 500ml": "/gears/04.svg",
    "foldable cup": "/gears/05.svg",
    "survival blanket": "/gears/06.svg",
    "first aid kits": "/gears/07.svg",
    "snack/energy bar": "/gears/08.svg",
    "windproof jacket": "/gears/09.svg",
    "rainproof jacket/poncho": "/gears/10.svg",
    "id card": "/gears/11.svg",
    whistle: "/gears/12.svg",
    headlamp: "/gears/13.svg",
    "cap/bandana": "/gears/14.svg",
    "running shoes": "/gears/15.png",
    "sufficient cash": "/gears/16.svg",
    "trekking poles": "/gears/17.png",
  };
  return gearIconMap[gearName.toLowerCase()] || "/gears/default-gear.svg";
};

// Component untuk CheckCircle
export const CheckCircle = () => (
  <span
    className="inline-flex items-center justify-center text-cyan-600 flex-shrink-0"
    aria-hidden="true"
  >
    <FontAwesomeIcon icon={faCheck} className="text-sm" />
  </span>
);

export const BMMDetail = () => {
  return <div>{/* Your updated BMMDetail content */}</div>;
};
